module.exports = __webpack_public_path__ + "static/media/axis-editing.d8010bb4.svg";